import { render, staticRenderFns } from "./targetcollectionfrm.vue?vue&type=template&id=4b099307"
import script from "./targetcollectionfrm.vue?vue&type=script&lang=js"
export * from "./targetcollectionfrm.vue?vue&type=script&lang=js"
import style0 from "./targetcollectionfrm.vue?vue&type=style&index=0&id=4b099307&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports